export const GOOGLE_PLACES_BASE_URL = "https://places.googleapis.com/v1";
export const GOOGLE_PLACES_TIMEOUT_MS = 10000;
export const GOOGLE_PLACE_FIELDS = "id,addressComponents,location";
export const GOOGLE_CITY_COMPONENT_TYPES = [
  "locality",
  "postal_town",
  "administrative_area_level_3",
  "administrative_area_level_2",
];
